<template>
  <div>
    <!-- main -->
    <main id="tutorial">
      <footer-app page="top" hide="false"></footer-app>
      
      <!-- about -->
      <section>
        <!-- l main -->
        <div class="l-main l-main--no-pd-bot pt-12">
          <!-- Swiper -->
          <div class="swiper-container js-about-swiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="l-about">
                  <div class="l-about__top mb-16">
                    <div class="l-about__title">
                      最新イベントやチラシ情報を <br />
                      一目でチェック
                    </div>
                    <div class="l-about__img">
                      <img src="/assets/images/tutorial/tutorial-1.png" alt="" />
                    </div>
                    <div class="l-about__description">
                      各ショップのイベント情報やチラシをまとめて確認できます。気になるイベントはお気に入り登録で事前にチェック！
                    </div>
                  </div>
                  <div class="l-auth__external-link pb-6">
                    <br>
                  </div>
                  <div class="l-about__bot">
                    <div v-on:click.stop.prevent="btn_next()" class="btn-tutorial box-center btn-next">次へ</div>
                  </div>
                  <div class="l-auth__external-link mb-24" v-if="!isFromHelpPage()">
                    <a v-on:click.stop.prevent="skip_tutorial()" href="">スキップする</a>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="l-about">
                  <div class="l-about__top mb-16">
                    <div class="l-about__title">
                      アプリ限定配信クーポンを確認
                    </div>
                    <div class="l-about__img">
                      <img src="/assets/images/tutorial/tutorial-2.png" alt="" />
                    </div>
                    <div class="l-about__description">
                      アプリ限定クーポンを配信中！お得にお買い物をお楽しみいただけます。
                    </div>
                  </div>
                  <div class="l-auth__external-link pb-6">
                    <br>
                  </div>
                  <div class="l-about__bot">
                    <div v-on:click.stop.prevent="btn_next()" class="btn-tutorial box-center btn-next">次へ</div>
                  </div>
                  <div class="l-auth__external-link mb-24" v-if="!isFromHelpPage()">
                    <a v-on:click.stop.prevent="skip_tutorial()" href="">スキップする</a>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="l-about">
                  <div class="l-about__top mb-16">
                    <div class="l-about__title">
                      気になるショップを詳しくみる
                    </div>
                    <div class="l-about__img">
                      <img src="/assets/images/tutorial/tutorial-3.png" alt="" />
                    </div>
                    <div class="l-about__description">
                      各ショップのページでは、それぞれのニュースやイベント情報、クーポンを簡単に確認できます。
                    </div>
                  </div>
                  <div class="l-auth__external-link">
                    <router-link to="/about/termsofuse" v-if="!isFromHelpPage()">利用規約を確認する</router-link>
                  </div>
                  <div class="l-about__bot">
                    <a v-on:click.stop.prevent="start_app()" href="" class="btn-tutorial box-center">
                      <template v-if="!isFromHelpPage()">
                        利用規約に同意して始める
                      </template>
                      <template v-else>
                        ヘルプTOPに戻る
                      </template>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <!-- Add Pagination -->
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Footer from "../components/Footer.vue";
import Swiper from "swiper";
import { Common } from "../common/common.js";

export default Vue.extend({
  name: "Tutorial",
  data() {
    return {
      about_swiper: {},
      fromPage: null,
      initialTab: Common.getUrlParam('tab') || 0
    }
  },
  components: {
    'footer-app': Footer,
  },
  created() {
    
    this.fromPage = Common.getUrlParam('from-page');

    Common.messageHandlers('set_bar_style', 'white')
  },
  mounted() {
    this.$store.dispatch('initialiseStore');
    let initialSlide = this.initialTab;

    // ヘルプから来ている場合は最初のページから開始させる
    if (this.isFromHelpPage()) {
      initialSlide = 0;
    }

    var _this = this;
    var about_swiper = new Swiper(".js-about-swiper", {
      initialSlide: initialSlide,
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      on: {
        slideChangeTransitionEnd: function () {
          if(!about_swiper) return;
          var n = about_swiper?.activeIndex || 0;
          if(n != _this.$route.query.tab){
            _this.$router.replace({ query: { tab: n } });
          }
        },
      }
    });
    this.about_swiper = about_swiper;
    Common.initDom();
  },
  methods: {
    isFromHelpPage() {
      return this.fromPage && this.fromPage == 'help';
    },
    btn_next(index) {
      this.about_swiper.slideNext();
      // チュートリアルのインデックスを保持
      if (this.isFromHelpPage()) {
        this.$store.dispatch('setTutorialIndex', this.about_swiper.activeIndex);
      }
    },
    skip_tutorial() {
      this.about_swiper.slideTo(5);
      
      if(this.$route.query.tab != 4){
        this.$router.replace({ query: { tab: 4 } });
      }
      // チュートリアルのインデックスを保持
      if (this.isFromHelpPage()) {
        this.$store.dispatch('setTutorialIndex', this.about_swiper.activeIndex);
      }
    },
    start_app() {
      if (this.isFromHelpPage()) {
        this.$router.go(-1);
      } else {
        this.$store.dispatch('finishTutorial');
        this.$router.push('/account/registration');
      }
    }
  }
})
</script>
